import { PDF_DETAIL } from './endpoint';

const baseUrl = process.env.NODE_ENV === 'development'
  ? (process.env.REACT_APP_API || 'https://gateway.qrcode-gen.com')
  : '';

export const getPdfQrcode = async (name) => {
  const response = await fetch(`${baseUrl}${PDF_DETAIL}/${encodeURIComponent(name)}`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.result) {
    throw new Error(payload.message || `Unable to load PDF information (${response.status})`);
  }
  return payload.result;
}
